import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class PtbrCodesEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      id: '',
      cdop: '',
      grpop: '',
      description: '',
      table_name: '',
      internal_use: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_ptbr_code.id !== 'undefined') {
        this.setState({
          cdop: newProps.data_ptbr_code.cdop,
          grpop: newProps.data_ptbr_code.grpop,
          description: newProps.data_ptbr_code.description,
          table_name: newProps.data_ptbr_code.table_name,
          internal_use: newProps.data_ptbr_code.internal_use,
          id: newProps.data_ptbr_code.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      cdop: this.state.cdop,
      grpop: this.state.grpop,
      description: this.state.description,
      table_name: this.state.table_name,
      internal_use: this.state.internal_use,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/codigo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tituloEditarCodigoPTBR}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.edit}> 
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.CDOP}:</label>
                    <input type="text" name="cdop" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.placeholder.CDOP} value={this.state.cdop} onChange={this.handleChange.bind(this, 'cdop')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.GRPOP}:</label>
                    <input type="text" name="grpop" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.placeholder.GRPOP} value={this.state.grpop} onChange={this.handleChange.bind(this, 'grpop')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.Descricao}:</label>
                    <input type="text" name="description" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.placeholder.Descricao} value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.Tabela}:</label>
                    <input type="text" name="table_name" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.placeholder.NomeDaTabela} value={this.state.table_name} onChange={this.handleChange.bind(this, 'table_name')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.UsoInterno}:</label>
                    <Select
                      className="form-field-name"
                      name="internal_use"
                      value={this.state.internal_use}
                      searchable={true}
                      placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.placeholder.SelecioneOUsoInterno}
                      onChange={this.handleSelectChange.bind(this, 'internal_use')}
                      options={[
                        {value: 1, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDePartida},
                        {value: 2, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDeDecolagem},
                        {value: 3, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDePouso},
                        {value: 4, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDeCorte},
                        {value: 5, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDeVoo},
                        {value: 6, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoDeAtraso},
                        {value: 7, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.opcoesUsoInterno.CodigoPadraoDeVoo},
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.forumlarioEditarCodigoPTBR.botaoEditarCodigoPTBR}</button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PtbrCodesEditModal;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/PtbrCodesEditModal.js